import { useState } from "react";
import { Link } from "react-router-dom";

const KEY = "fantini_cookie_consent";

export function CookieBanner() {
  const [choice, setChoice] = useState(() => localStorage.getItem(KEY));
  if (choice) return null;
  const decide = (v) => { localStorage.setItem(KEY, v); setChoice(v); };
  return (
    <div data-testid="cookie-banner" role="dialog" aria-label="Informativa cookie"
      className="fixed inset-x-3 bottom-3 md:inset-x-auto md:left-6 md:bottom-6 md:max-w-md z-[60] bg-ink text-white rounded-3xl p-5 md:p-6 shadow-floating">
      <div className="text-[11px] uppercase tracking-[0.2em] text-[#68b39d] mb-2">Cookie</div>
      <p className="text-sm text-white/80 leading-relaxed">
        Usiamo cookie tecnici necessari al funzionamento del sito e, solo con il tuo consenso, cookie di terze parti
        (es. pagamenti, contatto WhatsApp). Leggi la <Link to="/cookie-policy" className="underline text-white">Cookie Policy</Link>.
      </p>
      <div className="flex gap-2 mt-4">
        <button data-testid="cookie-accept" onClick={() => decide("all")}
          className="flex-1 h-11 rounded-full bg-[#68b39d] text-ink text-sm font-medium hover:opacity-90">Accetta</button>
        <button data-testid="cookie-reject" onClick={() => decide("necessary")}
          className="flex-1 h-11 rounded-full border border-white/30 text-sm hover:bg-white/10">Solo necessari</button>
      </div>
    </div>
  );
}
